import { Services } from '@/infra/services';
import { type Data } from '@/infra/services/checkout/cart/get-cart-summary';

export interface GetCartSummaryProps extends Data {}

export async function getCartSummary(props: Readonly<GetCartSummaryProps>) {
  const { cartId, paymentMethod, installments } = props;

  return await Services.Checkout.Cart.getCartSummary({
    cartId,
    paymentMethod,
    installments,
  });
}
